export function isObject(value: unknown): value is object {
    return typeof value === 'object' && value !== null;
}

export function isString(value: unknown): value is string {
    return typeof value === 'string';
}

export function isNumber(value: unknown): value is number {
    return typeof value === 'number' && Number.isFinite(value);
}

export function isBoolean(value: unknown): value is boolean {
    return typeof value === 'boolean';
}

export function isNull(value: unknown): value is null {
    return value === null;
}

export function isUndefined(value: unknown): value is undefined {
    return value === undefined;
}

export function isNullish(value: unknown): value is null | undefined {
    return value === null || value === undefined;
}

export function isNumberOrNullish(value: unknown): value is number | undefined {
    return isNumber(value) || isNullish(value);
}

export function isStringOrNullish(value: unknown): value is string | undefined {
    return isString(value) || isNullish(value);
}

export function isNotNullish<T>(value: T | undefined | null): value is T {
    return value !== null && value !== undefined;
}

export function isEmpty(value: unknown): value is Empty {
    return (
        value === '' ||
        value === null ||
        value === undefined ||
        (Array.isArray(value) && value.length === 0)
    );
}

type Empty = '' | null | undefined | unknown[];
